// extracted by mini-css-extract-plugin
export var phone = "_2m-0";
export var phoneDragging = "_2m-1";